export default __webpack_public_path__ + "static/media/giro_de_empresas.3f43cc86.svg";